<jhi-bary-card class="card-container-contact m-3" *ngIf="transporterMember">
  <div header class="p-3">
    <h4>{{ transporterMember.firstName }} {{ transporterMember.lastName }}</h4>
    <span>{{ transporterMember.positionHeld }}</span>
  </div>
  <div body>
    <div *ngIf="getPicture()" class="image-upload-logo" [style]="getStyle()" [class.image-background]="getPicture()"></div>
    <div class="row">
      <div class="col-auto" *ngIf="transporterMember.phone">
        <div class="d-inline-flex align-items-baseline">
          <jhi-bary-icon icon="phone" size="lg"></jhi-bary-icon>
          <p class="pl-2 lead">{{ transporterMember.phone }}</p>
        </div>
      </div>
    </div>
    <div class="row" *ngIf="transporterMember.mail">
      <div class="col-auto">
        <div class="d-inline-flex align-items-baseline">
          <jhi-bary-icon icon="envelope" size="lg"></jhi-bary-icon>
          <p class="lead">
            <a class="pl-2" [href]="'mailto:' + transporterMember.mail">{{ transporterMember.mail }} </a>
          </p>
        </div>
      </div>
    </div>
    <div class="row" *ngIf="transporterMember.description">
      <div class="col-12">
        <div class="d-inline-flex align-items-center">
          <jhi-bary-icon icon="comment" size="lg"></jhi-bary-icon>
          <p class="pl-2 pb-0 mb-0 lead">{{ transporterMember.description }}</p>
        </div>
      </div>
    </div>
  </div>
</jhi-bary-card>
